import { Children, useReducer, useState } from "react";
import {
  //   Chip,
  TableRow,
  TableCell,
  Typography,
  TableBody,
  styled,
  IconButton,
  MenuItem,
  Menu,
  Box,
  Button,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { memo } from "utils/memo";
import T from "utils/constants/T";
import { get, orderBy } from "lodash";
import { getUserDisplayName } from "utils/helper";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import CashDDialog from "components/common/CashDDialog";
import { Grid } from "@mui/material";
import CashDAutocomplete from "components/common/CashDAutocomplete";
import { StyledBodyTypography, StyledTitleTypography } from "../CompanyTab/CompanyInfo";
import { Stack } from "@mui/material";
import { assignNewCompany, changeRole, disable2FA, enable2FA } from "store/reducers/employer";
import { fetchCompanies } from "store/reducers/dashboardSearch";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderTop: "inherit",
  overflow: "hidden",
  padding: "8px 0px 8px 10px",
}));

interface ViewEmployerListBodyProps {
  allTableRows: any[];
  page: number;
  rowsPerPage: number;
  totalTableRowsCount: number;
  totalPageCount: number;
  opan: boolean;
  anchorEl: any;
  handleClick: any;
  handleClose: any;
  companyId: string;
  systemCode: string;
}

const ViewEmployerListBody = ({
  allTableRows = [],
  page,
  rowsPerPage,
  totalTableRowsCount,
  totalPageCount,
  opan,
  anchorEl,
  handleClick,
  handleClose,
  companyId,
  systemCode,
}: ViewEmployerListBodyProps) => {
  const dispatch = useDispatch();

  const [selectedUserID, setSelectedUserID] = useState("");
  const [selectedUserName, setSelecteduserName] = useState("");
  const [selectedUserEmail, setSelectedUserEmail] = useState("");
  const [selectedUserCompanyId, setselectedUserCompanyId] = useState("");
  const [selectedUserRole, setSelectedUserRole] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCompanyModalOpen, setIsCompanyModalOpen] = useState(false);
  const [localState, setLocalState] = useReducer(
    (prevState: any, newState: any) => ({ ...prevState, ...newState }),
    {
      roleList: "",
      searchinput: "",
    }
  );
  let { roleList, searchInput } = localState;
  const roleListItem: any[] = [T.EMPLOYER_ADMIN, T.EMPLOYER_USER, T.PAYROLL_OFFICER_LABEL];
  let { companiesList } = useSelector((state: any) => state.dashboardSearch);
  let { isCashDSuperAdmin, isEmployerAdmin } = useSelector(
    (state: any) => state.auth
  );
  const loggedInUserId = useSelector((state: any) => state.auth.user?._id);
  const { isLoading } = useSelector((state: any) => state.employerListData);

  const role = (roleName: string) => {
    if (roleName === "superadmin") {
      return T.SUPER_ADMIN;
    } else if (roleName === "employer") {
      return T.EMPLOYER_ADMIN;
    } else if (roleName === "manager") {
      return T.EMPLOYER_USER;
    } else if (roleName === T.PAYROLL_OFFICER) {
      return T.PAYROLL_OFFICER_LABEL;
    } else {
      return T.UNKOWN_ROLE;
    }
  };

  const handleEdit = (userId: string) => {
    setSelectedUserID(userId);
    setIsModalOpen(true);
     const user = allTableRows.find((row) => row._id === userId);
    const rolename = get(user, "role.name", "");
    const readableRole = role(rolename); 
    setLocalState({ roleList: readableRole });
      handleClose();
  };

  const handleAssignNewCompany = (
    userId: string,
    userEmail: string,
    userName: string
  ) => {
    setSelectedUserID(userId);
    setSelecteduserName(userName);
    setSelectedUserEmail(userEmail);
    setIsCompanyModalOpen(true);
    handleClose();
  };
  const handleCloseEditModal = () => {
    setIsModalOpen(false);
  };
  const handleCompanyModalClose = () => {
    setIsCompanyModalOpen(false);
  };

  const handle2FA = async () => {
      const selectedEmployee = allTableRows.find((r) => r._id === selectedUserID);
      const isEnabled = get(selectedEmployee, "is_mobile_otp_enabled");
      if(!isEnabled){
        await dispatch(enable2FA(selectedUserID));
        handleClose();
      }
      else{
        await dispatch(disable2FA(selectedUserID));
        handleClose();
      }
    };

  const NO_COMPANY_SELECTED = {
    company_name: "",
  };
  const handleAutoCompleteChange = (type: string, newValue: any) => {
    if (newValue === null) {
      setLocalState({ [type]: NO_COMPANY_SELECTED });
    } else if (newValue) {
      console.log(newValue, "newValue");
      setLocalState({ [type]: newValue });
    }
  };

  let debounceTimer: any = null;
  const handleOnChangeValue = async (searchText: string) => {
    clearTimeout(debounceTimer);

    if (searchText?.length >= 3) {
      debounceTimer = setTimeout(() => {
        dispatch(fetchCompanies(searchText));
      }, 500);
    }
  };
  const handleRoleChange = (name: string, value: string) => {
    if (value === T.EMPLOYER_ADMIN) {
      value = "employer";
      dispatch(changeRole({ userId: selectedUserID, role: value }));
      handleCloseEditModal();
    } else if (value === T.EMPLOYER_USER) {
      value = "manager";
      dispatch(changeRole({ userId: selectedUserID, role: value }));
      handleCloseEditModal();
    } else if (value === T.PAYROLL_OFFICER_LABEL) {
      dispatch(changeRole({ userId: selectedUserID, role: T.PAYROLL_OFFICER }));
      handleCloseEditModal();
    }
  };

   const handleNewCompany = () => {
    const payload = {
      email: selectedUserEmail,
      companyId: selectedUserCompanyId,
      newCompanyId: searchInput._id,
    };
    dispatch(assignNewCompany(payload));
    handleCompanyModalClose();
  };

  return (
    <>
      <TableBody>
      {isLoading ? (
        <TableRow>
          <StyledTableCell colSpan={10} sx={{ border: "none" }}>
            <Typography variant="body1" textAlign="center">
              {T.LOADING}
            </Typography>
          </StyledTableCell>
        </TableRow>
      ) : (
        <>
        {Children.toArray(
          allTableRows.map((record, index) => {
            const rolename = get(record, "role.name", "");
            const registrationDate = get(record, "createdAt", "")
              ? get(record, "createdAt", "")
              : get(record, "created_date", "");
            const registrationDateText =
              moment(registrationDate).format("DD MMM yyyy h:mm A");
            const userName = getUserDisplayName(record);
            return (
              <TableRow
                sx={{ background: "white" }}
                key={record?.system_employee_id}
              >
                <StyledTableCell>
                  {" "}
                  {get(record, "companies.company_name", "")
                    ? get(record, "companies.company_name", "")
                    : "N/A"}
                </StyledTableCell>
                <StyledTableCell>{userName}</StyledTableCell>
                <StyledTableCell>{get(record, "email", "")}</StyledTableCell>
                <StyledTableCell>{role(rolename)}</StyledTableCell>
                <StyledTableCell>{registrationDateText}</StyledTableCell>
                {(isCashDSuperAdmin || isEmployerAdmin) && (
                  <StyledTableCell>
                    <IconButton
                      //  id="basic-button"
                      aria-controls={"basic-menu"}
                      aria-haspopup="true"
                      onClick={(e: any) => {
                        handleClick(e);
                        setSelectedUserID(record?._id);
                        setSelecteduserName(userName);
                        setSelectedUserEmail(get(record, "email", ""));
                        setSelectedUserRole(role(rolename));
                        setselectedUserCompanyId(
                          get(record, "companies._id", "")
                        );
                      }}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </StyledTableCell>
                )}
              </TableRow>
            );
          })
        )}

        {allTableRows && allTableRows.length === 0 && (
          <TableRow>
            <StyledTableCell colSpan={10} sx={{ border: "none" }}>
              <Typography variant="body1" textAlign="center">
                {T.NO_RECORDS}
              </Typography>
            </StyledTableCell>
          </TableRow>
        )}
        </>
        )}
      </TableBody>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        keepMounted
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={() => {
            handleEdit(selectedUserID);
          }}
          disabled={
            selectedUserRole === T.SUPER_ADMIN ||
            selectedUserID === loggedInUserId
          }
        >
          {T.UPDATE_ROLE}
        </MenuItem>
        {isCashDSuperAdmin && (
          <MenuItem
            onClick={() => {
              handleAssignNewCompany(
                selectedUserID,
                selectedUserEmail,
                selectedUserName
              );
            }}
              disabled={selectedUserRole === T.SUPER_ADMIN}
          >
            {T.ASSIGN_NEW_COMPANY}
          </MenuItem>
        )}
        {isCashDSuperAdmin && (
          <MenuItem onClick={handle2FA}>
            {" "}
            {get(
              allTableRows.find((r) => r._id === selectedUserID),
              "is_mobile_otp_enabled"
            )
              ? "Disable 2FA"
              : "Enable 2FA"}
          </MenuItem>
        )}
      </Menu>
      <CashDDialog open={isModalOpen} handleClose={handleCloseEditModal}>
        <>
          <Typography variant="h4" sx={{ mt: 2, textAlign: "center" }}>
            {T.UPDATE_ROLE}
          </Typography>
          <Grid container sx={{ mt: 2 }}>
            <Box
              sx={{
                borderRadius: "1px",
                width: "100%",
                border: "1px solid  rgb(230, 235, 241)",
                textAlign: "center",
                p: 3,
              }}
            >
              <Stack padding={2}>
                <Grid container spacing={8} sx={{ alignItems: "center" }}>
                  <Grid item xs={3}>
                    <StyledBodyTypography sx={{ flexWrap: "nowrap" }}>
                      {T.ROLE}
                    </StyledBodyTypography>
                  </Grid>
                  <Grid item xs={9}>
                    <CashDAutocomplete
                      placeholder={T.SELECT}
                      fullWidth
                      listDetails={roleListItem}
                      value={roleList}
                      getByLabelText={(option: any) => option}
                      onHandleChange={(event: any, newValue: any) =>
                        handleRoleChange("roleList", newValue)
                      }
                    />
                  </Grid>
                </Grid>
              </Stack>
            </Box>
          </Grid>
        </>
      </CashDDialog>
       <CashDDialog
        open={isCompanyModalOpen}
        handleClose={handleCompanyModalClose}
      >
        <>
          <Typography variant="h4" sx={{ mt: 2, textAlign: "center" }}>
            {T.ASSIGN_NEW_COMPANY}
          </Typography>
          <Stack spacing={2}>
            <Stack padding={2}>
              <Grid container spacing={6} sx={{ alignItems: "center" }}>
                <Grid item xs={3}>
                  <StyledBodyTypography>{T.NAME}</StyledBodyTypography>
                </Grid>
                <Grid item xs={9}>
                  <StyledTitleTypography>
                    {selectedUserName}
                  </StyledTitleTypography>
                </Grid>
              </Grid>
            </Stack>
            <Stack padding={2}>
              <Grid container spacing={6} sx={{ alignItems: "center" }}>
                <Grid item xs={3}>
                  <StyledBodyTypography>{T.EMAIL}</StyledBodyTypography>
                </Grid>
                <Grid item xs={9}>
                  <StyledTitleTypography>
                    {selectedUserEmail}
                  </StyledTitleTypography>
                </Grid>
              </Grid>
            </Stack>
            <Stack padding={2}>
              <Grid container spacing={6} sx={{ alignItems: "center" }}>
                <Grid item xs={3}>
                  <StyledBodyTypography sx={{ flexWrap: "nowrap" }}>
                    {T.COMPANY_NAME}
                  </StyledBodyTypography>
                </Grid>
                <Grid item xs={9}>
                  <Box>
                    <CashDAutocomplete
                      placeholder={T.ALL_COMPANIES}
                      handleOnChangeValue={(e: any) => {
                        handleOnChangeValue(e.target.value);
                      }}
                      listDetails={orderBy(
                        companiesList,
                        ["company_name"],
                        ["asc"]
                      )}
                      value={searchInput}
                      getByLabelText={(option: any) =>
                        get(option, "company_name", "")
                      }
                      onHandleChange={(event: any, newValue: any) => {
                        handleAutoCompleteChange("searchInput", newValue);
                      }}
                      isOptionEqualToValue={(option: any, value: any) =>
                        option._id === value._id
                      }
                    />
                  </Box>
                </Grid>
              </Grid>
            </Stack>
          </Stack>
          <Stack padding={2} direction="row" justifyContent="space-between">
            <Button
              // variant="outlined"
              color="secondary"
              onClick={handleCompanyModalClose}
            >
              Back
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              onClick={handleNewCompany}
            >
              Submit
            </Button>
          </Stack>
        </>
      </CashDDialog>
    </>
  );
};

export default memo(ViewEmployerListBody);
